<template>
    <div
            class="second-level-select"
            :class="{
                'second-level-select__label_top': labelOnTop,
            }"
    >
        <span
                v-if="label"
                class="label"
        >
            {{ label }}
        </span>
        <b-dropdown
                class="second-level-select-dropdown dropdown-list"
                :class="{
                    'second-level-select-dropdown__full': fullWidthDropdown
                }"
                no-flip
                :menu-class="[
                    'p-0',
                    {
                        'show': isAlwaysOpened,
                    }
                ]"
                :toggle-class="[
                    'text-truncate',
                    'align-items-center',
                    'align-content-center',
                    'shadow-none',
                    {
                        'd-flex': !isAlwaysOpened,
                        'd-none': isAlwaysOpened,
                    }
                ]"
                :no-caret="disableCaret"
                :disabled="loading || disabled"
                variant="primary"
                ref="dropdown"
                boundary="window"
        >
            <template #button-content>
                <slot name="dropdownToggleContent">
                    <b-spinner
                            v-if="loading"
                            label="Loading..."
                            class="spinner"
                    />
                    <span
                            v-else
                            class="mb-0 dropdown-title text-truncate placeholder"
                    >
                        {{ placeholder }}
                    </span>
                </slot>
            </template>
            <div class="parent-dropdown-content">
                <b-input-group
                        v-if="withSearchInput"
                        class="search-input-group"
                >
                    <b-form-input placeholder="Search..." />
                    <template #append>
                        <i class="fa-regular fa-magnifying-glass" />
                    </template>
                </b-input-group>
                <span
                        v-if="dropdownTitle"
                        class="parent-dropdown-title"
                >
                    {{ dropdownTitle }}
                </span>
                <li
                        v-for="(option, optionIndex) in options"
                        :key="`parent-item-index-${optionIndex}`"
                        class="parent-list-item"
                        :class="{
                            'parent-list-item__active': option[parentValueKey] === parentValue
                        }"
                        @click="parentClick(optionIndex)"
                >
                    <div class="parent-list-item-text">
                        <span>{{ option[parentLabelKey] }}</span>
                        <i class="right-chevron fa-solid fa-chevron-right" />
                    </div>
                    <ul
                            class="child-content"
                            :class="{
                                'child-content__active': optionIndex === activeParentIndex
                            }"
                            :style="childContentStyle"
                    >
                        <li
                                v-if="childDropdownTitle"
                                class="child-list-item child-list-item__gray"
                        >
                              <span class="child-dropdown-title">
                                {{ childDropdownTitle }}
                              </span>
                        </li>
                        <li
                                v-for="(childOption, childOptionIndex) in option[childKeyIdentifier] || []"
                                :key="`child-item-index-${childOptionIndex}`"
                                class="child-list-item"
                                @click="childClick(option, childOption)"
                        >
                            <span>{{ childOption[childLabelKey] }}</span>
                            <i
                                    v-if="childValue === childOption[childValueKey] && option[parentValueKey] === parentValue"
                                    class="checkmark fa-solid fa-check"
                            />
                        </li>
                    </ul>
                </li>
            </div>
        </b-dropdown>
    </div>
</template>

<script>
import './SecondLevelSelect.scss';

export default {
    name: 'SecondLevelSelect',

    props: {
        disableCaret: {
            type: Boolean,
            default: false,
        },
        isAlwaysOpened: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        fullWidthDropdown: {
            type: Boolean,
            default: false,
        },
        label: {
            type: String,
        },
        labelOnTop: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            required: true,
        },
        withSearchInput: {
            type: Boolean,
            default: false,
        },
        dropdownTitle: {
            type: String,
        },
        options: {
            type: Array,
            required: true,
        },
        parentLabelKey: {
            type: String,
            default: 'name',
        },
        parentValueKey: {
            type: String,
            default: 'uuid',
        },
        childDropdownTitle: {
            type: String,
        },
        childKeyIdentifier: {
            type: String,
            required: true,
        },
        childLabelKey: {
            type: String,
            default: 'name',
        },
        childValueKey: {
            type: String,
            default: 'uuid',
        },
        parentValue: {
            type: [String, Number],
        },
        childValue: {
            type: [String, Number],
        },

        // Variations
        disableChildVariation : {
            type: Boolean,
            default: false,
        },
        childVariationMarginTop: {
            type: String,
            default: '2.9rem',
        }
    },

    data() {
        return {
            activeParentIndex: null,
            activeChildIndex: null,
            childContentStyle: {},
        };
    },

    methods: {
        parentClick(optionIndex) {
            if (!this.disableChildVariation) {
                const variation = this.options[optionIndex][this.childKeyIdentifier]?.length || 0;
                this.childContentStyle = {
                    marginTop: `calc(${this.childVariationMarginTop} * ${variation})`,
                };
            }

            this.activeParentIndex === optionIndex
                ? this.activeParentIndex = null
                : this.activeParentIndex = optionIndex;
        },

        childClick(option, childOption) {
            this.$emit('event-selected', {
                parentValue: option[this.parentValueKey],
                childValue: childOption[this.childValueKey],
            });

            // Close dropdown
            this.$refs.dropdown.hide();
        },
    }
};
</script>
